/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.Configuration", ["require", "exports", "SuiteCommerce.GiftCertificate.Utils.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OptionTilesConfiguration = void 0;
    var OptionTilesConfiguration = /** @class */ (function (_super) {
        __extends(OptionTilesConfiguration, _super);
        function OptionTilesConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(OptionTilesConfiguration, "itemOptionsLabel", {
            get: function () {
                return this.get('giftcertadvanced.itemOptionsLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OptionTilesConfiguration, "giftOptionButtonLabel", {
            get: function () {
                return this.get('giftcertadvanced.giftOptionButtonLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OptionTilesConfiguration, "useThumbnailInButtonLabel", {
            get: function () {
                return this.get('giftcertadvanced.useThumbnailInButtonLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OptionTilesConfiguration, "searchApiMasterOptions", {
            get: function () {
                return this.get('searchApiMasterOptions');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(OptionTilesConfiguration, "groupCertificatesAsItemOptions", {
            get: function () {
                return this.get('giftcertadvanced.groupCertificatesAsItemOptions');
            },
            enumerable: false,
            configurable: true
        });
        return OptionTilesConfiguration;
    }(Configuration_1.Configuration));
    exports.OptionTilesConfiguration = OptionTilesConfiguration;
});
